import request from '@/utils/request'
//1. DrawBlkQty
export function onBlkQtyRetrieve(param) {
    let data = param
    return request({
      url: `/v20/onBlkQtyRetrieve`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}
//2. DrawBlkQty2
export function getBlkCnt(param) {
    let data = param
    return request({
      url: `/v20/getBlkCnt`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}  
//3. drawFlatFormList
export function onFlatFormListRetrieve(param) {
  let data = param
  return request({
    url: `/v20/onFlatFormListRetrieve`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  
//4. DrawBlkSuppBeam
export function onBlkSuppBeamRetrieve(param) {
  let data = param
  return request({
    url: `/v20/onBlkSuppBeamRetrieve`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

//5. drawShipEvent
export function onBlkShipEventRetrieve(param) {
  let data = param
  return request({
    url: `/v20/onBlkShipEventRetrieve`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//6. LoadYardObjList
export function getYardObj(param) {
  let data = param
  return request({
    url: `/v20/getYardObj`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//7. drawBorder
export function getLastConfirm(param) {
  let data = param
  return request({
    url: `/v20/getLastConfirm`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//8. LoadBlkList
export function getAddObjBlk(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/getAddObjBlk`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
//9. drawShip
export function getDockArrangeList(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/getDockArrangeList`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
//10. listShipNo
export function listShipNo(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/listShipNo`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
 
